'use client';
import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function PublicFooter() {
  return (
    <footer className="bg-[#0F172A] text-slate-300">
      {/* Top gradient bar */}
      <div className="h-1 bg-gradient-to-r from-[#16A34A] via-[#38BDF8] to-[#F59E0B]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand col */}
          <div className="md:col-span-4 space-y-5">
            <Link href="/" className="flex items-center gap-2.5">
              <AppLogo size={40} variant="white" />
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
              Kenya&apos;s Trusted Peer-to-Peer Travel Marketplace.
            </p>
            <p className="text-xs text-[#38BDF8] italic font-medium">
              &ldquo;Every Traveler is a Courier. Every Route is a Delivery.&rdquo;
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-xl bg-white/5 hover:bg-[#16A34A]/20 border border-white/10 hover:border-[#16A34A]/40 flex items-center justify-center transition-all duration-200 group">
                <svg className="w-4 h-4 text-slate-400 group-hover:text-[#16A34A]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a href="#" className="w-9 h-9 rounded-xl bg-white/5 hover:bg-[#16A34A]/20 border border-white/10 hover:border-[#16A34A]/40 flex items-center justify-center transition-all duration-200 group">
                <svg className="w-4 h-4 text-slate-400 group-hover:text-[#16A34A]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a href="#" className="w-9 h-9 rounded-xl bg-white/5 hover:bg-[#16A34A]/20 border border-white/10 hover:border-[#16A34A]/40 flex items-center justify-center transition-all duration-200 group">
                <svg className="w-4 h-4 text-slate-400 group-hover:text-[#16A34A]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-2 space-y-4">
            <h4 className="font-heading text-white font-bold text-sm uppercase tracking-widest">Platform</h4>
            <ul className="space-y-2.5">
              {['Browse Trips', 'Create Order', 'Marketplace', 'Active Deliveries']?.map((item) => (
                <li key={item}>
                  <Link href="/sign-up-login-screen" className="text-sm text-slate-400 hover:text-[#38BDF8] transition-colors">{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2 space-y-4">
            <h4 className="font-heading text-white font-bold text-sm uppercase tracking-widest">Company</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'About Us', href: '/about' },
                { label: 'Contact', href: '/contact' },
                { label: 'Careers', href: '#' },
                { label: 'Blog', href: '/blog' },
              ]?.map((item) => (
                <li key={item?.label}>
                  <Link href={item?.href} className="text-sm text-slate-400 hover:text-[#38BDF8] transition-colors">{item?.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4 space-y-4">
            <h4 className="font-heading text-white font-bold text-sm uppercase tracking-widest">Stay Updated</h4>
            <p className="text-sm text-slate-400">Get the latest routes, deals, and platform updates.</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="your@email.com"
                className="flex-1 px-4 py-2.5 rounded-xl bg-white/5 border border-white/10 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-[#16A34A]/50 focus:bg-white/8 transition-all"
              />
              <button className="px-4 py-2.5 rounded-xl bg-[#16A34A] text-white text-sm font-heading font-bold hover:bg-[#15803D] transition-colors shrink-0">
                Subscribe
              </button>
            </div>
            <div className="flex items-center gap-2 pt-2">
              <div className="w-2 h-2 rounded-full bg-[#16A34A] animate-pulse" />
              <span className="text-xs text-slate-400">Available across Kenya — 280+ active routes</span>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
            <p className="text-xs text-slate-500">
              © {new Date()?.getFullYear()} MuyuRide Ltd. All rights reserved. Registered in Kenya.
            </p>
            <span className="hidden sm:inline text-slate-700">·</span>
            <p className="text-xs text-[#38BDF8]/70 italic">Kenya&apos;s Trusted Peer-to-Peer Travel Marketplace</p>
          </div>
          <div className="flex items-center gap-6">
            {[
              { label: 'Privacy Policy', href: '/privacy-policy' },
              { label: 'Terms of Service', href: '/terms-of-service' },
              { label: 'Refund Policy', href: '/refund-policy' },
              { label: 'Insurance', href: '/insurance' },
            ]?.map((item) => (
              <Link key={item?.label} href={item?.href} className="text-xs text-slate-500 hover:text-[#38BDF8] transition-colors">
                {item?.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
